<div class="collapse">
  <p class="collapse-trigger text-07-m-demibold text-01-d-light white" [class.alert]="sectionDetails.IsError" (click)="toggleActive()">
    {{ sectionDetails.SerialNumber }}. {{ sectionDetails.Title }}
    <span class="icon icon-alert" *ngIf="!isValidSection(sectionDetails)"></span>
    <span class="icon icon-arrow-right visible-xs"></span>
    <span class="icon icon-chevron-down hidden-xs" [class.active]="isActive"></span>
    <span class="message-error in" *ngIf="!isValidSection(sectionDetails)">Por favor, completa las preguntas que faltan</span>
  </p>
  <div class="collapsed" [class.active]="isActive">
    <div class="modify-title step">
      <span class="collapse-horizontal-trigger icon icon-arrow-left" (click)="toggleActive()"></span>
      <p class="text-10-m-demibold white">{{ sectionDetails.SerialNumber }}. {{ sectionDetails.Title }}</p>
      <span class="icon icon-cancel" (click)="toggleActive()"></span>
    </div>
    <ul class="submenu">
      <ng-container *ngFor="let details of questionDetailsModel">
        <single-column-sw [question]="details" [contractType]="contractType" [sectionDetails]="sectionDetails"> </single-column-sw>
      </ng-container>
    </ul>
  </div>
</div>
